var translations = {
    de: {
        step1: 'Person',
        step2: 'Vorhaben',
        step3: 'Einkommen',
        step4: 'Beratung',
        applicant: 'Kreditnehmer',
    },
};
export default translations;
